import * as server from "@/utils/http"

export const _getRoleList = params => server.getByStreetCode("/sysRole/selectPages", params); // 列表
export const _getAllRole = params => server.getByStreetCode("/sysRole/findChild", params); // 列表
export const getRoleById = params => server.getByStreetCode("/sysRole/queryRoleById", params); // 列表
export const _delRole = params => server.getByStreetCode("/sysRole/delete", params); // 删除
export const _editRole = params => server.postByStreetCode(params.id ? "/sysRole/update" : "/sysRole/save", params); // 编辑/创建

/**
 * 获取表单基础数据
 * @param params
 * @returns {*}
 */
export const getAllBaseData = params => server.getByStreetCode("/sysRole/getBaseData?", params); // 列表
